import { useState, useEffect } from "react";
import { Mountain, Sparkles } from "lucide-react";
import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import { DestinationCard, DestinationCardSkeleton } from "@/components/shared/DestinationCard";
import axios from "axios";
import { API } from "@/App";

export default function ExperienciasPage() {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const response = await axios.get(`${API}/public/experiences?limit=20`);
        setExperiences(response.data.items);
      } catch (error) {
        console.error("Error fetching experiences:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchExperiences();
  }, []);

  return (
    <Layout>
      {/* Hero */}
      <PageHero
        section="experiencias"
        title="Experiencias"
        subtitle="Vive aventuras únicas en Honduras. Desde tours culturales hasta actividades de aventura extrema."
        badge="Aventura"
        badgeIcon={Sparkles}
      />

      {/* Grid */}
      <section className="py-12 md:py-16" data-testid="experiences-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => <DestinationCardSkeleton key={i} />)}
            </div>
          ) : experiences.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {experiences.map((post) => (
                <DestinationCard key={post.post_id} post={{ ...post, post_type: "experience" }} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <Mountain className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No hay experiencias publicadas aún</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
